let voice: SpeechSynthesisVoice | undefined;

// sleight of hand to communicate internal testing tools'
// experimental voices to "problemJS" readAloud functions
declare global {
  interface Window {
    gmmVoicePicker?: SpeechSynthesisVoice;
  }
}

// Whether we have ever called the speech synthesis 'speak' method.
// Needed as part of working around iOS's requirement for user interaction
// coupled with its refusal to recognize a touchstart on a canvas as user interaction.
let spoke = false;

const DEFAULT_SPEECH_RATE = 0.7;

// We've found that there some Voices handle speeds differently. For example,
// the default voice on Android sounds much too slow at .5
const speechRates: Map<string, number> = new Map([
  ['Alex', 0.5],
  ['Microsoft David - English (United States)', 0.6],
]);

export function getVoiceRate(voiceToRead: SpeechSynthesisVoice): number {
  return speechRates.get(voiceToRead.name) || DEFAULT_SPEECH_RATE;
}

export function hasSpoken(): boolean {
  return spoke;
}

export function setSpoke(spokeValue: boolean): void {
  spoke = spokeValue;
}

export function getVoice(): SpeechSynthesisVoice | undefined {
  // Use internal tool chosen voice, if it exists (see 'qa' or 'WebProblemTester' tools)
  return window.gmmVoicePicker || voice;
}

export function setVoice(voiceToUse: SpeechSynthesisVoice | undefined): void {
  voice = voiceToUse;
}

export function isSpeechAvailable(): boolean {
  return !!getVoice();
}
